/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Access_SuspendedInputs */



/**
* | output |
* | --- |
* | "Building access is suspended" |
*
* @param {Building_Access_SuspendedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_access_suspended = /** @type {((inputs?: Building_Access_SuspendedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Access_SuspendedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Building access is suspended")
	return /** @type {LocalizedString} */ ("L'accès au bâtiment est suspendu")
});